import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      dashboard: 'Dashboard',
      clients: 'Clients',
      operations: 'Operations',
      users: 'Users',
      
      // Dashboard
      totalClients: 'Total Clients',
      totalCompanies: 'Total Companies',
      totalEmployees: 'Total Employees',
      totalTransactions: 'Total Transactions',
      pendingTransactions: 'Pending Transactions',
      
      // Clients
      addClient: 'Add Client',
      clientName: 'Client Name',
      phone: 'Phone',
      balance: 'Balance',
      totalDeposits: 'Total Deposits',
      totalSpent: 'Total Spent',
      actions: 'Actions',
      viewDetails: 'View Details',
      addDeposit: 'Add Deposit',
      amount: 'Amount',
      depositDate: 'Deposit Date',
      notes: 'Notes',
      deposits: 'Deposits',
      companies: 'Companies',
      addCompany: 'Add Company',
      companyName: 'Company Name',
      
      // Operations
      selectCompany: 'Select Company',
      employees: 'Employees',
      addEmployee: 'Add Employee',
      employeeName: 'Employee Name',
      passportNumber: 'Passport Number',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      
      // Employee Details
      employeeInfo: 'Employee Information',
      employeeFiles: 'Employee Files',
      employeeTransactions: 'Employee Transactions',
      passport: 'Passport',
      passportCover: 'Passport Cover',
      photo: 'Photo',
      visa: 'Visa/Cancellation',
      idFront: 'ID Front',
      idBack: 'ID Back',
      certificateFront: 'Certificate Front',
      certificateBack: 'Certificate Back',
      contract: 'Contract',
      otherDocuments: 'Other Documents',
      uploadFile: 'Upload File',
      
      // Transactions
      addTransaction: 'Add Transaction',
      mainType: 'Main Type',
      subType: 'Sub Type',
      workDate: 'Work Date',
      durationDays: 'Duration (Days)',
      price: 'Price',
      actualPaidAmount: 'Actual Paid Amount',
      pending: 'Pending',
      completed: 'Completed',
      cancelled: 'Cancelled',
      
      // Transaction Types
      new_residence: 'New Residence',
      renewal: 'Residence Renewal',
      cancellation: 'Cancellation',
      temp_work_permit: 'Temporary Work Permit',
      other: 'Other',
      
      // Users
      addUser: 'Add User',
      username: 'Username',
      password: 'Password',
      role: 'Role',
      admin: 'Admin',
      owner: 'Owner',
      client: 'Client',
      
      // Common
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      confirm: 'Confirm',
      loading: 'Loading...',
      noData: 'No data available',
      success: 'Success',
      error: 'Error',
      areYouSure: 'Are you sure?',
      search: 'Search',
      searchEmployee: 'Search employee...',
      remainingBalance: 'Remaining Balance',
      totalAmount: 'Total Amount',
      completedTransactions: 'Completed Transactions',
      totalCompletedTransactions: 'Total Completed Transactions',
      totalCompanyAmount: 'Total Company Amount',
      client: 'Client',
      transactions: 'Transactions',
      companyName: 'Company Name',
      selectEmployee: 'Select Employee',
      netProfit: 'Net Profit',
      totalTransactionPrice: 'Total Transaction Price',
      startDate: 'Start Date',
      endDate: 'End Date',
      language: 'Language',
      selectLanguage: 'Select Language',
      arabic: 'Arabic',
      english: 'English',
      languageRequired: 'Language selection is required',
      exportExcel: 'Export Excel',
      companyTransactions: 'Company Transactions',
      companyTransactionsTotal: 'Total Company Transactions',
      transaction: 'Transaction',
      company: 'Company',
      nationality: 'Nationality',
      recentCompanyTransactions: 'Recent Company Transactions',
    }
  },
  ar: {
    translation: {
      // Navigation
      dashboard: 'لوحة التحكم',
      clients: 'العملاء',
      operations: 'إدارة العمليات',
      users: 'المستخدمين',
      
      // Dashboard
      totalClients: 'إجمالي العملاء',
      totalCompanies: 'إجمالي المنشآت',
      totalEmployees: 'إجمالي الموظفين',
      totalTransactions: 'إجمالي المعاملات',
      pendingTransactions: 'المعاملات المعلقة',
      
      // Clients
      addClient: 'إضافة عميل',
      clientName: 'اسم العميل',
      phone: 'الهاتف',
      balance: 'الرصيد',
      totalDeposits: 'إجمالي الإيداعات',
      totalSpent: 'إجمالي المصروف',
      actions: 'الإجراءات',
      viewDetails: 'عرض التفاصيل',
      addDeposit: 'إضافة إيداع',
      amount: 'المبلغ',
      depositDate: 'تاريخ الإيداع',
      notes: 'ملاحظات',
      deposits: 'الإيداعات',
      companies: 'المنشآت',
      addCompany: 'إضافة منشأة',
      companyName: 'اسم المنشأة',
      
      // Operations
      selectCompany: 'اختر المنشأة',
      employees: 'الموظفين',
      addEmployee: 'إضافة موظف',
      employeeName: 'اسم الموظف',
      passportNumber: 'رقم الجواز',
      status: 'الحالة',
      active: 'نشط',
      inactive: 'غير نشط',
      
      // Employee Details
      employeeInfo: 'معلومات الموظف',
      employeeFiles: 'ملفات الموظف',
      employeeTransactions: 'معاملات الموظف',
      passport: 'جواز السفر',
      passportCover: 'غلاف الجواز',
      photo: 'صورة شخصية',
      visa: 'التأشيرة/الإلغاء',
      idFront: 'الهوية (الوجه)',
      idBack: 'الهوية (الظهر)',
      certificateFront: 'الشهادة (الوجه)',
      certificateBack: 'الشهادة (الظهر)',
      contract: 'العقد',
      otherDocuments: 'مستندات أخرى',
      uploadFile: 'رفع ملف',
      
      // Transactions
      addTransaction: 'إضافة معاملة',
      mainType: 'النوع الرئيسي',
      subType: 'النوع الفرعي',
      workDate: 'تاريخ العمل',
      durationDays: 'المدة (بالأيام)',
      price: 'السعر',
      actualPaidAmount: 'المبلغ المدفوع فعلياً',
      pending: 'معلق',
      completed: 'مكتمل',
      cancelled: 'ملغى',
      
      // Transaction Types
      new_residence: 'إقامة جديدة',
      renewal: 'تجديد إقامة',
      cancellation: 'إلغاء',
      temp_work_permit: 'تصريح عمل مؤقت',
      other: 'أخرى',
      
      // Users
      addUser: 'إضافة مستخدم',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      role: 'الصلاحية',
      admin: 'مدير',
      owner: 'مالك',
      client: 'عميل',
      
      // Common
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      close: 'إغلاق',
      confirm: 'تأكيد',
      loading: 'جاري التحميل...',
      noData: 'لا توجد بيانات',
      success: 'نجح',
      error: 'خطأ',
      areYouSure: 'هل أنت متأكد؟',
      search: 'بحث',
      searchEmployee: 'ابحث عن موظف...',
      remainingBalance: 'الرصيد المتبقي',
      totalAmount: 'المبلغ الإجمالي',
      completedTransactions: 'المعاملات المكتملة',
      totalCompletedTransactions: 'إجمالي المعاملات المكتملة',
      totalCompanyAmount: 'إجمالي مبلغ المنشأة',
      client: 'العميل',
      transactions: 'المعاملات',
      companyName: 'اسم المنشأة',
      selectEmployee: 'اختر الموظف',
      netProfit: 'صافي الربح',
      totalTransactionPrice: 'إجمالي سعر المعاملات',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      language: 'اللغة',
      selectLanguage: 'اختر اللغة',
      arabic: 'العربية',
      english: 'الإنجليزية',
      languageRequired: 'اختيار اللغة مطلوب',
      exportExcel: 'تصدير Excel',
      companyTransactions: 'معاملات المنشأة',
      companyTransactionsTotal: 'إجمالي معاملات المنشآت',
      transaction: 'المعاملة',
      company: 'المنشأة',
      nationality: 'الجنسية',
      recentCompanyTransactions: 'أحدث معاملات المنشآت',
    }
  }
};

// Get saved language from localStorage or default to Arabic
const savedLanguage = typeof window !== 'undefined' ? localStorage.getItem('appLanguage') : null;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage || 'ar',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
